import { css } from 'styled-components'

export const getScrollbarStyles = () => css`
  scrollbar-color: rgba(255, 255, 255, 0.5);
  scrollbar-width: thin;
`
